import { render, staticRenderFns } from "./ComplianceWidgetEmployee.vue?vue&type=template&id=0e409da2&scoped=true&lang=pug"
import script from "./ComplianceWidgetEmployee.vue?vue&type=script&lang=ts"
export * from "./ComplianceWidgetEmployee.vue?vue&type=script&lang=ts"
import style0 from "./ComplianceWidgetEmployee.vue?vue&type=style&index=0&id=0e409da2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e409da2",
  null
  
)

/* custom blocks */
import block0 from "./ComplianceWidgetEmployee.i18.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FCompliance%2FComplianceWidgets%2FComplianceWidgetEmployee.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports